import ProducerService from 'src/modules/producer/producerService';
import Errors from 'src/modules/shared/error/errors';
import { navigateTo } from 'src/view/shared/routes/helpers';

const prefix = 'PRODUCER_VIEW';

const producerViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: producerViewActions.FIND_STARTED,
      });

      const record = await ProducerService.find(id);

      dispatch({
        type: producerViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: producerViewActions.FIND_ERROR,
      });

      navigateTo('/library/producer');
    }
  },
};

export default producerViewActions;
